<!--template>
  <div>
    <input type="password" v-model="password" placeholder="请输入密码" />
    <button @click="submitPassword">确认</button>
  </div>
</template-->
<template>  
  <div class="password-container">  
    <h2 class="title">请输入密码</h2>  
    <input  
      type="password"  
      class="password-input"  
      v-model="password"  
      placeholder="输入密码"  
      @keyup.enter="submitPassword"  
    />  
    <button class="password-button" @click="submitPassword">确认</button>  
  </div>  
</template>  
<script>
	import config from "../../config";
	import {
		checkPublicPoolPassword,
	} from "../../api/user";
	import {
		mapMutations,
		mapActions,
		mapGetters
	} from "vuex";
export default {
	
  data() {
    return {
      password: '',
	  errorTimes:0
    }
  },
  computed: {
  	...mapGetters(['token', 'userInfo']),
  },
  methods: {
    async submitPassword() {
      // 进行密码验证的逻辑，这里使用假设的密码 "123456"
	  let that = this;
	  var data = {
	  	token: this.token,
		password:this.password,
		errorTimes:this.errorTimes
	  };
	  let res = await checkPublicPoolPassword(that, data);
	  if (res.code == 1) {
			this.$emit('passwordCorrect')
	  }else if(res.code == 2){
		   this.errorTimes++;
		   alert('密码错误')
	  }else{
		  alert('密码错误')
	  }
    },
  }
}
</script>
<style scoped>  
.password-container {  
  display: flex;  
  flex-direction: column;  
  align-items: center;  
  justify-content: center;  
  height: 100vh; /* 使容器占据整个视口高度 */  
  background-color: #f5f5f5; /* 背景色 */  
}  
  
.title {  
  font-size: 24px;  
  margin-bottom: 20px;  
}  
  
.password-input {  
  width: 300px; /* 输入框宽度 */  
  padding: 10px; /* 内边距 */  
  font-size: 16px; /* 字体大小 */  
  margin-bottom: 20px; /* 下边距 */  
  border: 1px solid #ccc; /* 边框 */  
  border-radius: 4px; /* 边框圆角 */  
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06); /* 内阴影，增加立体感 */  
}  
  
.password-input:focus {  
  outline: none; /* 移除轮廓 */  
  border-color: #80bdff; /* 聚焦时边框颜色 */  
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); /* 聚焦时阴影 */  
}  
  
.password-button {  
  padding: 10px 20px; /* 内边距 */  
  font-size: 16px; /* 字体大小 */  
  color: #fff; /* 文字颜色 */  
  background-color: #007bff; /* 背景色 */  
  border: none; /* 无边框 */  
  border-radius: 4px; /* 边框圆角 */  
  cursor: pointer; /* 鼠标悬停时显示手形光标 */  
}  
  
.password-button:hover {  
  background-color: #0056b3; /* 鼠标悬停时的背景色 */  
}  
  
.error-message {  
  color: red; /* 错误消息颜色 */  
  margin-top: 10px; /* 上边距 */  
}  
</style>
